import React from 'react'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import asideModalStore from 'Stores/asideModalStore'
import st from './CreatePartition.module.scss'
import { observer } from 'mobx-react'
import SelectCustom from '../../../ContentBox/Global/Select/SelectCustom'
import useLocalization from 'hooks/useLocalization'

const CreatePartition = ({ parentPartitions }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'user',
    subsection: 'translator',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      search: 'Search',
      search_input: 'Search by student name, surname, or patronymic...',
      date: 'Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      filter: 'Filter',
      changeTranslation: 'Change translation',
      createTranslation: 'Create translation',
      text: 'Text',
      language: 'Language',
      partition: 'Partition',
      subpartition: 'Subpartition',
      page: 'page',
      englishText: 'English Text',
      english: 'English',
      kazakhAndRussian: 'Kazakh / Russian text',
      russian: 'Russian',
      kazakh: 'Kazakh',
      creatingTranslation: 'Creating a new translation',
      createPartition: 'Create Partition',
      of: 'of',
      name: 'Name',
      shortName: 'Short name',
      parentPartition: 'Parent Partition',
    },
  })

  const handleChange = (e, field) => {
    changeValues(e.target.value, field)
  }

  return (
    <FormFieldset>
      <div className={st.field}>
        <FormField>
          <FormLabel isRequired>{translate?.name}: </FormLabel>
          <FormInput isError={check('name')}>
            <input
              placeholder={translate?.name}
              type='text'
              value={modalValue.name || ''}
              onChange={(e) => handleChange(e, 'name')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>{translate?.shortName}: </FormLabel>
          <FormInput isError={check('short_name')}>
            <input
              placeholder={translate?.shortName}
              type='text'
              value={modalValue.short_name || ''}
              onChange={(e) => handleChange(e, 'short_name')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel>{translate?.parentPartition}: </FormLabel>
          <FormInput isError={check('parent_partition')}>
            <SelectCustom
              placeholder={translate?.parentPartition}
              options={parentPartitions}
              sortKey='parent_partition'
              valueID={modalValue?.parent_partition?.id}
              onChange={(o) => changeValues(o, 'parent_partition')}
              error={check('parent_partition')}
            />
          </FormInput>
        </FormField>
      </div>
    </FormFieldset>
  )
}

export default observer(CreatePartition)
